import { Shark, View } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { documentListView } from "./documentListView";
import { documentManager } from "../../_shark_jaws/managers/documentManager";

import templateContent from "./document-edit.html";
import { breadcrumbComponent } from "../../_shark_jaws/components/breadcrumbComponent";


class DocumentEditView extends View {
	constructor () {
		super("documentEditView");
		this.setTemplate(templateContent);
	}





	backToDocumentListBtn_clickHandler () {
		Shark.openPage(documentListView);
	}

	beforeLoad () {
		breadcrumbComponent.set("isActive", false);
	}

	beforeRender () {
		this.set({
			editingDocument: Shark.get("editingDocument"),
			productLineList: Shark.get("productLineList"),
			// __cdnURL: process.env.CDN_URL,
			__isEditing: Shark.get("isEditing"),
			__thumbnailName: Shark.__generateGUID(),
		});
	}

	cancelEditsBtn_clickHandler () {
		const editingDocument = Shark.get("editingDocument");
		
		if (!editingDocument.__isDirty || (editingDocument.__isDirty && confirm("Sei sicuro di voler annullare le modifiche apportate?"))) {
			editingDocument.restore();
			Shark.set("isEditing", false);

			if (editingDocument.guid !== "") {
				this.set({
					__isEditing: Shark.get("isEditing")
				});
				Shark.render();
			}
			else {
				Shark.openPage(documentListView);
			}
		}
	}

	deleteDocumentBtn_clickHandler () {
		if (confirm("Sei sicuro di voler eliminare il documento?")) {
			documentManager.delete();
		}
	}

	deleteFileBtn_clickHandler () {
		const newDocument = Shark.get("editingDocument");

		newDocument.set("fileSize", 0);
		newDocument.set("fileType", "");
		newDocument.set("fileURL", "");

		Shark.render();
	}

	documentManager_documentDeletedHandler () {
		Shark.openPage(documentListView);
	}

	documentManager_savedHandler () {
		console.log("documentSavedHandler");
		Shark.set("isEditing", !Shark.get("isEditing"));
		this.set({
			__isEditing: Shark.get("isEditing")
		});
		Shark.openPage(documentListView);
	}

	documentManager_documentSaveErrorHandler () {
		console.log("documentSaveErrorHandler");
	}

	editDocumentBtn_clickHandler () {
		Shark.set("isEditing", !Shark.get("isEditing"));
		this.set({
			__isEditing: Shark.get("isEditing")
		});
		Shark.render();
	}

	init () {
		this.addComponents([breadcrumbComponent, mainNavComponent]);
	}

	fileOverrideConfirmation (path, name, type) {
		if (confirm("Il file che stai cercando di caricare esiste già. Vuoi comunque caricarlo?")) {
			documentManager.uploadDuplicate(path, name, type);
		}
		else {
			const newDocument = Shark.get("editingDocument");

			newDocument.set("fileSize", 0);
			newDocument.set("fileType", "");
			newDocument.set("fileURL", "");
			newDocument.set("name", "");

			Shark.render();
		}
	}

	profileImageDeleteBtn_clickHandler () {
		Shark.get("editingDocument").set("thumbnailURL", "");
		Shark.render();
	}

	saveDocumentBtn_clickHandler () {
		documentManager.save(Shark.get("editingDocument"));
	}

	uploadedFile_changeHandler (event) {
		NousCore.api.uploadFiles(event.target, "document/upload")
		.then(function(jsonData) {
			const savedFile = jsonData.payload.items[0];


			switch (savedFile.rc) {
				case 1:
					const newDocument = Shark.get("editingDocument");

					if (newDocument.name === "") {
						newDocument.set("name", savedFile.name);
					}
					newDocument.set("fileSize", savedFile.size);
					newDocument.set("fileType", savedFile.type);
					newDocument.set("fileURL", savedFile.filePath);
					break;
				case 95:
					documentEditView.fileOverrideConfirmation(savedFile.errors[0].erroData.tempFile, savedFile.errors[0].erroData.originalName, "fileURL");
					break;
				default:
					alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
			}

			Shark.render();
		});
	}

	uploadedThumbnail_changeHandler (event) {
		NousCore.api.uploadFiles(event.target, "document/upload")
		.then(function(jsonData) {
			const savedFile = jsonData.payload.items[0];

			switch (savedFile.rc) {
				case 1:
					const newDocument = Shark.get("editingDocument");
					newDocument.set("thumbnailURL", savedFile.filePath);
					break;
				case 95:
					documentEditView.fileOverrideConfirmation(savedFile.errors[0].erroData.tempFile, savedFile.errors[0].erroData.originalName, "thumbnailURL");
					break;
				default:
					alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
			}

			Shark.render();
		});
	}
}

const documentEditView = new DocumentEditView();

Shark.registerView(documentEditView);

export { documentEditView };
